export default __webpack_public_path__ + "static/media/switch2.80ef7120.svg";